jQuery(document).ready(function($){
  $('.model h3').click(function(){
    $(this).next('ul').slideToggle();
    $(this).toggleClass('open');
  });

  $('#model-1 ul li').click(function(){
    let handle = $(this).attr('data-handle');
    let title = $(this).attr('data-title');

    jQuery.getJSON('/products/'+handle+'.js', function(product) {
      console.log(product);
      let option_media_ary = [];
      let om_item = {
      }
      product.media.forEach((media)=>{
        let alt = media.alt,
            src = media.src.replace(/(\.[\w\d?=_-]+)$/i, '_300x$1');
        if(alt != null) {
          if(alt.includes(',')) {
            alt.split(',').forEach(alt_s=>{
              om_item[alt_s] = src;
            });
          } else {
            om_item[alt] = src;
          }
        }
      });

      option_media_ary.push(om_item);
      console.log('size>>>',option_media_ary[0]);

      let{id,options:[a,b,c]}=product;
      let{values}=a;
      let size_li ='';
      console.log(product.options.length);
      for(size of values){
        let cls = (option_media_ary[0][size] != null)?'':'hide';
        size_li += '<li class="Size_li"><div class="modelimg-wrap"><img src="'+option_media_ary[0][size]+'" class="'+cls+'"><h2>'+size+'</h2></div></li>';
      }

      $('#model-2').addClass('active');
      $('#model-2 ul').html(size_li);
    } );


    $('#model-2 h3').text('Select Size');
    $('#model-3 h3').text('Select Weight');
    $('#model-4 h3').text('Select Profile');
    $('#model-2 h3').removeClass('sucess');
    $('#model-3 h3').removeClass('sucess');
    $('#model-4 h3').removeClass('sucess');
    $(this).parents('.model').find('h3').text(title);
    $(this).parents('.model').find('h3').addClass('sucess');
    $(this).parents('.model').find('h3').removeClass('open');
    $(this).addClass('active2');
    $(this).siblings('li').removeClass('active2');
    $(this).parent('ul').hide();
    $('div#model-3').removeClass('active');
    $('div#model-3 ul').hide();
    $('div#model-4').removeClass('active');
    $('div#model-4 ul').hide();

  });

  /**********/
  $(document).on('click', '.Size_li', function(){
    let handle = $('#model-1 ul li.active2').attr('data-handle');
    let firstoption = $(this).text();
    jQuery.getJSON('/products/'+handle+'.js', function(product) {
      console.log(product);
      let option_media_ary = [];
      let om_item = {
      }
      product.media.forEach((media)=>{
        let alt = media.alt,
            src = media.src.replace(/(\.[\w\d?=_-]+)$/i, '_300x$1');
        if(alt != null) {
          if(alt.includes(',')) {
            alt.split(',').forEach(alt_s=>{
              om_item[alt_s] = src;
            });
          } else {
            om_item[alt] = src;
          }
        }
      });

      option_media_ary.push(om_item);
      console.log('weight>>>',option_media_ary[0]);

      let{id,variants}=product;
      let weight_li ='';
      for(varriant of variants){
        if(firstoption == varriant.option1){
          //     console.log(varriant.id+"=="+varriant.option1+"=="+varriant.option2);
          if (weight_li.includes(varriant.option2) === false){
            let weight = varriant.option2;
            let cls = (option_media_ary[0][weight] != null)?'':'hide';
            weight_li += '<li class="weight_li"><div class="modelimg-wrap"><img src="'+option_media_ary[0][weight]+'" class="'+cls+'"><h2>'+weight+'</h2></div></li>';

            //             weight_li += '<li class="weight_li">'+varriant.option2+'</li>';
          }


        }
      }
      $('#model-3').addClass('active');
      $('#model-3 ul').html(weight_li);

    } );

    $('#model-3 h3').text('Select Weight');
    $('#model-4 h3').text('Select Profile');
    $('#model-3 h3').removeClass('sucess');
    $('#model-4 h3').removeClass('sucess');
    $(this).parents('.model').find('h3').text(firstoption);
    $(this).parents('.model').find('h3').addClass('sucess');
    $(this).parents('.model').find('h3').removeClass('open');
    $(this).addClass('active3');
    $(this).siblings('li').removeClass('active3');
    $(this).parent('ul').hide();
    $('div#model-3').removeClass('active');
    $('div#model-3 ul').hide();
    $('div#model-3').removeClass('active');
    $('div#model-3 ul').hide();
    $('div#model-4').removeClass('active');
    $('div#model-4 ul').hide();
  });

  /**********/ 
  $(document).on('click', '.weight_li', function(){
    let handle = $('#model-1 ul li.active2').attr('data-handle');
    let firstoption = $('li.Size_li.active3').text();
    let secondoption = $(this).text();
    jQuery.getJSON('/products/'+handle+'.js', function(product) {

      console.log(product);
      let option_media_ary = [];
      let om_item = {
      }
      product.media.forEach((media)=>{
        let alt = media.alt,
            src = media.src.replace(/(\.[\w\d?=_-]+)$/i, '_300x$1');
        if(alt != null) {
          if(alt.includes(',')) {
            alt.split(',').forEach(alt_s=>{
              om_item[alt_s] = src;
            });
          } else {
            om_item[alt] = src;
          }
        }
      });


      option_media_ary.push(om_item);
      console.log('weight>>>',option_media_ary[0]);

      let{id,variants}=product;
      let middleposition_li ='';
      for(varriant of variants){
        if(firstoption == varriant.option1 & secondoption == varriant.option2){

          let last = varriant.option3;
          let cls = (option_media_ary[0][last] != null)?'':'hide';
          middleposition_li += '<li class="middleposition_li"><div class="modelimg-wrap"><img src="'+option_media_ary[0][last]+'" class="'+cls+'"><h2>'+last+'</h2></div></li>';
          //           middleposition_li += '<li class="middleposition_li">'+varriant.option3+'</li>';

        }
      }
      $('#model-4').addClass('active');
      $('#model-4 ul').html(middleposition_li);

    } );


    $(this).parents('.model').find('h3').text(secondoption);
    $(this).parents('.model').find('h3').addClass('sucess');
    $(this).parents('.model').find('h3').removeClass('open');
    $(this).addClass('active4');
    $(this).siblings('li').removeClass('active4');
    $(this).parent('ul').hide();
    $('div#model-4').removeClass('active');
    $('div#model-4 ul').hide();
    $('#model-4 h3').text('Select Profile');
    $('#model-4 h3').removeClass('sucess');
  });

  /*****/
  $(document).on('click', '.middleposition_li', function(){
    $(this).addClass('active5');
    $(this).siblings('li').removeClass('active5');
    $(this).parent('ul').hide();
    $(this).parents('.model').find('h3').text($(this).text());
    $(this).parents('.model').find('h3').addClass('sucess');
    $(this).parents('.model').find('h3').removeClass('open');
  });




  $('.selectbox h5').click(function(){
    $(this).next('ul').slideToggle();
    $(this).toggleClass('open');
  });

  $('.selectbox ul li').click(function(){
    let dataname = $(this).attr('data-name');
    let gripcheck = $(this).attr('data-grip');
    $(this).parents('.selectbox').find('h5').text(dataname);
    $(this).parents('.selectbox').find('h5').addClass('success');
    $(this).parents('.selectbox').find('h5').removeClass('open');
    $(this).parents('.selectbox').find('ul').hide();
    $(this).addClass('active');
    $(this).siblings('li').removeClass('active');
    if(gripcheck == 'yes' ){
      if(dataname == 'yes' ){
        $('input#extragrip-qty, .extragrip_price').show();
        //         $('input#extragrip-qty').attr('max', $(this).attr('data-max'));
        $('.extragrip_price').html($(this).attr('data-price'));

      } else{
        $('input#extragrip-qty, .extragrip_price').hide();
      }
    }

    if($(this).attr('data-font') == "true"){
      $(this).closest('.container-model-wrap').addClass('active');
      $(this).closest('.container-model-wrap').find('.fontimg img').show();
      $(this).closest('.container-model-wrap').find('.fontimg img').attr('src',$(this).attr('data-img'));
      let fontname= $(this).closest('.container-model-wrap').find('li.active').text();
      
      $(this).closest('.container-model-wrap').attr('data-title',fontname);
    }
  });

  /*******add to cart btn********/ 

  $(document).on('click', '#bundleBtn', function(){
    let variant_arrays = [];

    let model = $('div#model-1 ul li.active2').attr('data-handle');
    if(model == undefined){
      alert('select the model');
      return;
    }


    let modelSize = $('div#model-2 ul li.active3').text();
    if(modelSize == ''){
      alert('select the size');
      return;
    }


    let modelWeight = $('div#model-3 ul li.active4').text();
    if(modelWeight == ''){
      alert('select the weight');
      return;
    }


    let modelPosition = $('div#model-4 ul li.active5').text();
    if(modelPosition == ''){
      alert('select the Prfile');
      return;
    }


    //      let profileimg = $('input#profilepic').val();
    //      if(profileimg == ''){
    //       alert('choose profile image');
    //        return;
    //      }


    let thickness = $('#thickness ul li.active').attr('data-name');
    let thicknessProduct = $('#thickness ul li.active').attr('data-product');
    let thicknessImg = $('#thickness ul li.active').attr('data-img');
    if(thickness == undefined){
      alert('fill the thickness');
      return;
    }
    if(thicknessProduct != null && thicknessProduct != '') {
      variant_arrays.push(thicknessProduct);
    }


    let shape = $('#shape ul li.active').attr('data-name');
    let shapeProduct = $('#shape ul li.active').attr('data-product');
    let shapeImg = $('#shape ul li.active').attr('data-img');
    if(shape == undefined){
      alert('fill the shape');
      return;
    }
    if(shapeProduct != null && shapeProduct != '') {
      variant_arrays.push(shapeProduct);
    }


    let toetype = $('#toe-type ul li.active').attr('data-name');
    let toetypeProduct = $('#toe-type ul li.active').attr('data-product');
    let toetypeImg = $('#toe-type ul li.active').attr('data-img');
    if(toetype == undefined){
      alert('fill the toe type');
      return;
    }
    if(toetypeProduct != null && toetypeProduct != '') {
      variant_arrays.push(toetypeProduct);
    }


    let knocking = $('#free-knocking ul li.active').attr('data-name');
    let knockingProduct = $('#free-knocking ul li.active').attr('data-product');
    if(knocking == undefined){
      alert('fill the knocking');
      return;
    }
    if(knockingProduct != null && knockingProduct != '') {
      variant_arrays.push(knockingProduct);
    }

    let toebinding = $('#toe-binding ul li.active').attr('data-name');
    let toebindingProduct = $('#toe-binding ul li.active').attr('data-product');
    if(toebinding == undefined){
      alert('fill the toebinding');
      return;
    }
    if(toebindingProduct != null && toebindingProduct != '') {
      variant_arrays.push(toebindingProduct);
    }


    let scuffsheet = $('#scuff-sheet ul li.active').attr('data-name');
    let scuffsheetProduct = $('#scuff-sheet ul li.active').attr('data-product');
    let scuffsheetImg = $('#scuff-sheet ul li.active').attr('data-img');
    if(scuffsheet == undefined){
      alert('fill the toe scuff sheet');
      return;
    }
    if(scuffsheetProduct != null && scuffsheetProduct != '') {
      variant_arrays.push(scuffsheetProduct);
    }


    let extragrip  = $('#extra-grip ul li.active').attr('data-name');
    let extragripProduct = $('#extra-grip ul li.active').attr('data-product');
    if(extragrip == undefined){
      alert('fill the toe extragrip');
      return;
    }
    var grip_qty = 0;
    if(extragripProduct != null && extragripProduct != '') {
      grip_qty = $('#extragrip-qty').val();
      var grip_var_id = extragripProduct;
    }


    let properties = [];
    let p = {
      '__hasBase':true,
      'Thickness': thickness,
      'Shape': shape,
      'Toetype':toetype,
      'Knocking':knocking,
      'Toebinding':toebinding,
      'Scuffsheet':scuffsheet,
      'Extragrip':extragrip
    }

    $('.container-model-wrap.active').each(function(){
      var $el = $(this),
          $input = $el.find('.fontinput'),
          val = $input.val(),
          id = $el.data('product'),
          title = $el.data('title');
      console.log(id,title,val)
      if(val.length && id != null) {
        variant_arrays.push(id);
        p[title] = val;
      }
    });

    properties.push(p);


    jQuery.getJSON('/products/'+model+'.js', function(product) {       
      let{id,variants}=product;
      let modelproductvariantId ='';
      for(varriant of variants){
        if(modelSize == varriant.option1 & modelWeight == varriant.option2 & modelPosition == varriant.option3){
          modelproductvariantId += varriant.id;
        }
      } 


      console.log(modelproductvariantId, variant_arrays);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({id:modelproductvariantId,quantity:1,properties:properties[0]})
      })
      .then(response => {
        console.log(response)
        if(response.ok) {
          if(variant_arrays.length || grip_qty) {
            multiple_atc(variant_arrays, grip_qty , grip_var_id, modelproductvariantId);
          } else {
            window.location.href= '/cart';
          }
        } else {
          alert("something went wrong");
          console.log(response);
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });

  });


}); // ready


function multiple_atc(variant_arrays, grip_qty, grip_var_id, main_id) {
  var items=[];
  variant_arrays.forEach(id=> {
    var myObj = {
      "id" : parseInt(id),
      "quantity" : 1,
      "properties":{"__modal_addon":true, "__itemFor":main_id}
    };
    items.push(myObj);
  });

  if(grip_qty && grip_var_id != null) {
    var myObj = {
      "id" : parseInt(grip_var_id),
      "quantity" : parseInt(grip_qty),
      "properties":{"__modal_addon":true, "__itemFor":main_id}
    };
    items.push(myObj);
  }

  let formData = {
    'items': items
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    console.log(response)
    if(response.ok) {
      window.location.href= '/cart';
    } else {
      alert("some items are out of stock");
      console.log(response);
    }
    return response.json();
  })
}

function removeBundle(_this,event) {
  event.preventDefault();
  var $el = $(_this),
      removeItem_ids = [];
  fetch('/cart.js')
  .then(data=>{
    return data.json();
  })
  .then(cart=>{
    console.log(cart);
    cart.items.forEach((item)=>{
      if(item.properties['__modal_addon'] != null || item.properties['__hasBase']) {
        removeItem_ids.push(item.id);
      }
    });
    //     console.log(removeItem_ids)
    removeItems(removeItem_ids)
  });
}

const removeItems = (productIDS) => {
  let formData = {
    'updates': {}
  };
  //   console.log(productIDS);
  //   if(productIDS.includes(',')) {
  //     productIDS = productIDS.split(',');
  //     var productID;
  //     for (productID in productIDS) {
  //       console.log(productID)
  //       formData['updates'][parseInt(productIDS[productID])] = 0;
  //     }
  //   } else {
  //     formData['updates'][parseInt(productIDS)] = 0;
  //   }
  var productID;
  for (productID in productIDS) {
    //     console.log(productID)
    formData['updates'][parseInt(productIDS[productID])] = 0;
  }

  console.log(formData)
  let info = fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response =>{ 
    console.log(response);
    if(response.ok == 'false') {
      alert('Something went wrong!');
    }
    return response.json();
  }).then(data => {
    console.log(data)
    if(data != null) {
      location.reload();
    }
  }).catch((error) => {
    console.error('Error:', error);
  });


}



$('input#extragrip-qty').change(function(){
  let gripprice =  Number($('div#extra-grip .price').attr('data-price'));
  let gripqty =  Number($(this).val());

  $('div#extra-grip span.money').text('₹'+gripprice*gripqty);
  $('.extragrip_price span.money').text('₹'+gripprice*gripqty);
});

document.addEventListener('DOMContentLoaded', (e)=>{
  let freeknocking = document.querySelector('#free-knocking h5');
  if(freeknocking){
    freeknocking.innerText = 'Select Knocking (₹1000)'
  }
})